import React from "react";
import PropTypes from "prop-types";

const PublicIcon = (props) => {
  const { width = "86", height = "86" } = props;

  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 103 104"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.4467 39.7445C24.4335 37.5177 25.6834 35.4171 27.1698 33.4876L32.001 37.2094C30.8118 38.7531 29.8118 40.4336 29.0223 42.2152L23.4467 39.7445Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M80.1653 62.0429C79.202 64.8366 77.8379 67.4755 76.1156 69.8768L71.1599 66.3225C72.5379 64.4013 73.6293 62.2901 74.3999 60.055L80.1653 62.0429Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M32.1093 28.4207C34.0677 26.8309 36.2157 25.4903 38.5042 24.4295L41.069 29.9624C39.2381 30.8111 37.5196 31.8837 35.9528 33.1555L32.1093 28.4207Z"
        fill="url(#paint2_linear)"
      />
      <path
        d="M46.7275 21.9505C49.4287 21.538 52.1731 21.4904 54.887 21.809L54.176 27.8659C52.0048 27.611 49.8091 27.6491 47.648 27.9791L46.7275 21.9505Z"
        fill="url(#paint3_linear)"
      />
      <path
        d="M61.7438 23.4335C64.5701 24.46 67.229 25.8989 69.6343 27.7033L65.9746 32.5817C64.0503 31.138 61.923 29.9869 59.6619 29.1656L61.7438 23.4335Z"
        fill="url(#paint4_linear)"
      />
      <path
        d="M74.5952 32.3771C76.2313 34.3069 77.6209 36.4327 78.732 38.7056L73.2532 41.384C72.3643 39.5656 71.2525 37.8648 69.9436 36.3209L74.5952 32.3771Z"
        fill="url(#paint5_linear)"
      />
      <path
        d="M81.3537 46.7249C81.8749 49.6354 81.9701 52.6061 81.6363 55.544L75.5768 54.8555C75.8438 52.5051 75.7677 50.1284 75.3507 47.7999L81.3537 46.7249Z"
        fill="url(#paint6_linear)"
      />
      <path
        d="M20.8591 53.3985C20.7595 51.0592 20.9296 48.7162 21.366 46.4159L27.3576 47.5526C27.0084 49.393 26.8724 51.2675 26.9521 53.1391L20.8591 53.3985Z"
        fill="url(#paint7_linear)"
      />
      <path
        d="M25.0155 67.519C23.5922 65.0896 22.5121 62.4749 21.806 59.7492L27.7097 58.2199C28.2746 60.4006 29.1387 62.4925 30.2774 64.4362L25.0155 67.519Z"
        fill="url(#paint8_linear)"
      />
      <path
        d="M35.8617 78.3862C33.4173 76.9476 31.1855 75.175 29.2309 73.1197L33.65 68.917C35.2138 70.5613 36.9993 71.9795 38.955 73.1304L35.8617 78.3862Z"
        fill="url(#paint9_linear)"
      />
      <path
        d="M52.2777 82.5862C49.1805 82.6824 46.0868 82.306 43.103 81.4701L44.7483 75.5977C47.1354 76.2665 49.6106 76.5676 52.0884 76.4907L52.2777 82.5862Z"
        fill="url(#paint10_linear)"
      />
      <path
        d="M68.6741 77.1903C66.3966 78.7646 63.9153 80.0214 61.2987 80.9262L59.3057 75.1626C61.3991 74.4387 63.3843 73.4331 65.2064 72.1736L68.6741 77.1903Z"
        fill="url(#paint11_linear)"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear"
          x1="55.4814"
          x2="47.1818"
          y1="82.3172"
          y2="21.8846"
        >
          <stop offset="0.9998" stopColor="#00A550" />
          <stop offset="0.9999" stopColor="#3EBD7B" stopOpacity="0.0104167" />
          <stop offset="1" stopColor="#3FBD7B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear"
          x1="47.2376"
          x2="55.4248"
          y1="21.877"
          y2="82.3249"
        >
          <stop offset="0.9998" stopColor="#00A550" />
          <stop offset="0.9999" stopColor="#3EBD7B" stopOpacity="0.0104167" />
          <stop offset="1" stopColor="#3FBD7B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear"
          x1="41.2942"
          x2="61.3686"
          y1="80.902"
          y2="23.2999"
        >
          <stop offset="0.9998" stopColor="#00A550" />
          <stop offset="0.9999" stopColor="#3EBD7B" stopOpacity="0.0104167" />
          <stop offset="1" stopColor="#3FBD7B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint3_linear"
          x1="28.1043"
          x2="74.5578"
          y1="71.8687"
          y2="32.3332"
        >
          <stop offset="0.9998" stopColor="#00A550" />
          <stop offset="0.9999" stopColor="#3EBD7B" stopOpacity="0.0104167" />
          <stop offset="1" stopColor="#3FBD7B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint4_linear"
          x1="21.4713"
          x2="81.1913"
          y1="58.3157"
          y2="45.8862"
        >
          <stop offset="0.9998" stopColor="#00A550" />
          <stop offset="0.9999" stopColor="#3EBD7B" stopOpacity="0.0104167" />
          <stop offset="1" stopColor="#3FBD7B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint5_linear"
          x1="22.3222"
          x2="80.3401"
          y1="42.6816"
          y2="61.5203"
        >
          <stop offset="0.9998" stopColor="#00A550" />
          <stop offset="0.9999" stopColor="#3EBD7B" stopOpacity="0.0104167" />
          <stop offset="1" stopColor="#3FBD7B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint6_linear"
          x1="30.9739"
          x2="71.6888"
          y1="29.3893"
          y2="74.8126"
        >
          <stop offset="0.9998" stopColor="#00A550" />
          <stop offset="0.9999" stopColor="#3EBD7B" stopOpacity="0.0104167" />
          <stop offset="1" stopColor="#3FBD7B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint7_linear"
          x1="68.4563"
          x2="34.2066"
          y1="77.3393"
          y2="26.8622"
        >
          <stop offset="0.9998" stopColor="#00A550" />
          <stop offset="0.9999" stopColor="#3EBD7B" stopOpacity="0.0104167" />
          <stop offset="1" stopColor="#3FBD7B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint8_linear"
          x1="78.2824"
          x2="24.3806"
          y1="66.3801"
          y2="37.8218"
        >
          <stop offset="0.9998" stopColor="#00A550" />
          <stop offset="0.9999" stopColor="#3EBD7B" stopOpacity="0.0104167" />
          <stop offset="1" stopColor="#3FBD7B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint9_linear"
          x1="81.8247"
          x2="20.8391"
          y1="51.4408"
          y2="52.761"
        >
          <stop offset="0.9998" stopColor="#00A550" />
          <stop offset="0.9999" stopColor="#3EBD7B" stopOpacity="0.0104167" />
          <stop offset="1" stopColor="#3FBD7B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint10_linear"
          x1="76.7655"
          x2="25.897"
          y1="35.2681"
          y2="68.9338"
        >
          <stop offset="0.9998" stopColor="#00A550" />
          <stop offset="0.9999" stopColor="#3EBD7B" stopOpacity="0.0104167" />
          <stop offset="1" stopColor="#3FBD7B" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint11_linear"
          x1="63.5551"
          x2="39.1075"
          y1="24.1577"
          y2="80.0442"
        >
          <stop offset="0.9998" stopColor="#00A550" />
          <stop offset="0.9999" stopColor="#3EBD7B" stopOpacity="0.0104167" />
          <stop offset="1" stopColor="#3FBD7B" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

PublicIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PublicIcon;
